export const DEFAULT_LAYOUT = {
  en: {
    default: [
      "1 2 3 4 5 6 7 8 9 0 - =",
      "q w e r t y u i o p ",
      " {caps} a s d f g h j k l .",
      "{shift} z x c v b n m , {shift}",
      "{lang} {space | Space} {bksp}"
    ],
    shift: [
      "1 2 3 4 5 6 7 8 9 0 - =",
      "Q W E R T Y U I O P",
      "{caps} A S D F G H J K L . ",
      "{shift} Z X C V B N M , {shift}",
      "{lang} {space | Space} {bksp}"
    ],
    langName: 'English',
  },
  ru: {
    default: [
      "ё 1 2 3 4 5 6 7 8 9 0 - =",
      "й ц у к е н г ш щ з х ъ",
      "{caps} ф ы в а п р о л д ж э",
      "{shift} я ч с м и т ь б ю , . {shift}",
      "{lang} {space | Пробел} {bksp}"
    ],
    shift: [
      "Ё 1  2 3 4 5 6 7 8 9 0 - =",
      "Й Ц У К Е Н Г Ш Щ З Х Ъ",
      "{caps} Ф Ы В А П Р О Л Д Ж Э",
      "{shift} Я Ч С М И Т Ь Б Ю, . {shift}",
      "{lang} {space | Пробел} {bksp}"
    ],
    langName: 'Русский',
  },
};
export const DEFAULT_LANG = "en";
export const DEFAULT_CAPS = false;
export const DEFAULT_SHIFT = false;
export const ICONS = {
  lang: "fas fa-globe",
  caps: "fas fa-font",
  shift: "fas fa-arrow-up",
  bksp: "fas fa-backspace"
};
export const DEFAULT_BUTTONS = ['shift', 'caps', 'lang', 'space', 'bksp'];
